import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';
import { SettingItem, SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';

export function provideSettingsElementObjects(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'objects',
        name: 'Object Definitions',
        icon: 'pi pi-box',
        loadChildren: () =>
          import('./object-definitions.settings-routes').then(
            (m) => m.OBJECT_DEFINITIONS_SETTINGS_ROUTES
          ),
        order: 2.2,
        translateName: 'SCHEMA_BUILDER.DEFINITIONS.TITLE',
        resource_key: 'customObjectsDefinitions',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      } as SettingItem,
      multi: true,
    },
  ]);
}
